import { useState } from "react";
import { InfoIcon } from "@/shared/ui/icons/InfoIcon";
import { FullScreenDialog } from "@/shared/ui/FullScreenDialog";
import { PrivacyPolicyBody } from "@/public/features/site/pages/PrivacyPage";
import type { ProblemNewDraft } from "@/public/features/problem/types";
import { CONSENTS } from "@/public/features/problem/constants/problemNew";
import { Field, SectionHead } from "@/public/features/problem/ui/problemNew/parts";

export function StepConsent({ draft }: { draft: ProblemNewDraft }) {
  const isPhone = draft.contactChannel === "phone";
  const [policyOpen, setPolicyOpen] = useState(false);

  return (
    <>
      <section className="flex flex-col gap-3">
        <SectionHead
          title="등록 전 동의가 필요해요."
          desc="개인정보 수집·이용 내용을 확인하고 동의해 주세요."
        />
        <div className="flex flex-col gap-3">
          <Field
            label="이름"
            placeholder="이름을 적어주세요."
            value={draft.contactName}
            onChange={draft.setContactName}
            autoComplete="name"
          />

          <div className="flex flex-col gap-1">
            {isPhone ? (
              <Field
                label="휴대폰"
                placeholder="010-0000-0000"
                value={draft.contactPhone}
                onChange={draft.setContactPhone}
                type="tel"
                inputMode="numeric"
                autoComplete="tel"
                error={
                  draft.hasContactError
                    ? "휴대폰 번호 형식이 맞지 않습니다."
                    : null
                }
              />
            ) : (
              <Field
                label="이메일"
                placeholder="haebom@examle.com"
                value={draft.contactEmail}
                onChange={draft.setContactEmail}
                type="email"
                inputMode="text"
                autoComplete="email"
                error={
                  draft.hasContactError ? "이메일 형식이 맞지 않습니다." : null
                }
              />
            )}
            <button
              type="button"
              className="h-6 cursor-pointer self-start border-0 bg-none px-1 text-label font-medium text-black-300 after:block after:h-0 after:border-b after:border-black-100 after:content-[''] [&>*]:pointer-events-none"
              onClick={draft.switchContactChannel}
            >
              {isPhone ? "이메일로 받을게요" : "휴대폰으로 받을게요"}
            </button>
          </div>
        </div>
      </section>

      <section className="flex flex-col gap-3">
        {CONSENTS.map((c) => (
          <div key={c.key} className="flex flex-col gap-1">
            <label className="ui-pressable flex cursor-pointer items-center gap-2">
              <input
                type="checkbox"
                className="m-0 h-5 w-5 shrink-0 rounded accent-violet-500"
                checked={draft.consents.includes(c.key)}
                onChange={() => draft.toggleConsent(c.key)}
              />
              <span className="min-w-0 flex-1 shrink-0 grow basis-0 text-body-sm text-black-600">
                {c.label}
              </span>
            </label>
            <p className="m-0 pl-7 text-label font-normal text-black-200">
              {c.desc}
              <button
                type="button"
                className="ml-2 cursor-pointer border-0 bg-transparent p-0 text-label text-black-100 underline"
                onClick={() => setPolicyOpen(true)}
              >
                자세히
              </button>
            </p>
          </div>
        ))}

        <p className="m-0 flex items-center gap-1 text-label font-medium text-black-200 [&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0">
          <InfoIcon />
          <span>만 14세 미만은 보호자 동의를 받은 뒤 등록해주세요.</span>
        </p>
      </section>

      {policyOpen && (
        <FullScreenDialog
          title="개인정보 처리방침"
          onClose={() => setPolicyOpen(false)}
        >
          <PrivacyPolicyBody />
        </FullScreenDialog>
      )}
    </>
  );
}
